// ! This file was auto-generated from the unified-fields OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    addIntegrationMapping: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.ClientField, id: arg.fieldId }, { type: Tags.ClientField, id: "LIST" }]
    },
    bulkUpsertLookupTableRows: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    clearLookupTableCell: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    createClientFieldOverrides: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientFieldOverride, id: "LIST" }, { type: Tags.FieldOption, id: "LIST" }]
    },
    createField: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientField, id: "LIST" }]
    },
    createFieldLookupTable: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTable, id: "LIST" }]
    },
    createFieldLookupTableColumns: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableColumn, id: "LIST" }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    createFieldLookupTableRows: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    createFieldOptions: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldOption, id: "LIST" }]
    },
    createFieldSection: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldSection, id: "LIST" }]
    },
    createOptionSet: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.OptionSet, id: "LIST" }]
    },
    deleteClientFieldOverrides: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientFieldOverride, id: "LIST" }]
    },
    deleteField: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.ClientField, id: arg.fieldId }, { type: Tags.ClientField, id: "LIST" }, { type: Tags.FieldSection, id: "LIST" }]
    },
    deleteFieldOptions: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldOption, id: "LIST" }]
    },
    deleteFieldSection: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldSection, id: arg.sectionId }, { type: Tags.FieldSection, id: "LIST" }, { type: Tags.ClientField, id: "LIST" }]
    },
    deleteLookupTable: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTable, id: arg.tableId }, { type: Tags.FieldLookupTable, id: "LIST" }, { type: Tags.FieldLookupTableColumn, id: "LIST" }, { type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    deleteLookupTableColumn: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableColumn, id: arg.columnId }, { type: Tags.FieldLookupTableColumn, id: "LIST" }, { type: Tags.FieldLookupTableRow, id: "LIST" }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    deleteLookupTableRow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableRow, id: arg.rowId }, { type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    deleteOptionSet: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.OptionSet, id: arg.optionSetId }, { type: Tags.OptionSet, id: "LIST" }, { type: Tags.FieldOption, id: "LIST" }, { type: Tags.ClientField, id: "LIST" }, { type: Tags.ClientFieldOverride, id: "LIST" }]
    },
    getClientFieldOverride: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.ClientFieldOverride, id: arg.overrideId }]
    },
    getFieldLookupTableCell: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableCell, id: arg.cellId }]
    },
    getFieldLookupTableColumn: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableColumn, id: arg.columnId }]
    },
    getFieldLookupTableRow: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableRow, id: arg.rowId }]
    },
    getFieldSection: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldSection, id: arg.sectionId }, { type: Tags.ClientField, id: "LIST" }]
    },
    getLookupTable: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTable, id: arg.tableId }]
    },
    listClientFieldOverrides: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientFieldOverride, id: "LIST" }]
    },
    listFieldLookupTableColumns: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableColumn, id: "LIST" }]
    },
    listFieldLookupTableRows: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    listFieldOptions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldOption, id: "LIST" }]
    },
    listFields: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientField, id: "LIST" }]
    },
    listFieldSections: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldSection, id: "LIST" }, { type: Tags.ClientField, id: "LIST" }]
    },
    listLookupTables: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTable, id: "LIST" }]
    },
    liveness: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    moveSectionFields: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientField, id: "LIST" }, { type: Tags.FieldSection, id: "LIST" }]
    },
    readiness: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    removeIntegrationMapping: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.ClientField, id: arg.fieldId }, { type: Tags.ClientField, id: "LIST" }]
    },
    reorderFieldSections: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldSection, id: "LIST" }]
    },
    reorderLookupTableColumns: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableColumn, id: "LIST" }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    reorderLookupTableRows: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    reorderSectionFields: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientField, id: "LIST" }, { type: Tags.FieldSection, id: "LIST" }]
    },
    updateClientFieldOverrides: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ClientFieldOverride, id: "LIST" }, { type: Tags.FieldOption, id: "LIST" }]
    },
    updateField: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.ClientField, id: arg.fieldId }, { type: Tags.ClientField, id: "LIST" }, { type: Tags.ClientFieldOverride, id: "LIST" }]
    },
    updateFieldOption: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldOption, id: arg.optionId }, { type: Tags.FieldOption, id: "LIST" }]
    },
    updateFieldSection: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldSection, id: arg.sectionId }, { type: Tags.FieldSection, id: "LIST" }]
    },
    updateLookupTable: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTable, id: arg.tableId }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    updateLookupTableCell: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    updateLookupTableColumn: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableColumn, id: arg.columnId }, { type: Tags.FieldLookupTableColumn, id: "LIST" }, { type: Tags.FieldLookupTable, id: "LIST" }]
    },
    updateLookupTableRow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.FieldLookupTableRow, id: arg.rowId }, { type: Tags.FieldLookupTableRow, id: "LIST" }]
    },
    updateOptionSet: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.OptionSet, id: arg.optionSetId }, { type: Tags.OptionSet, id: "LIST" }, { type: Tags.FieldOption, id: "LIST" }]
    }
} as const;
